/**
 * 服务成果管理控制器
 */
export default class ServiceAchievementController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/view', 'get', params, axiosOption, httpOption);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/delete', 'post', params, axiosOption, httpOption);
  }

  static importData (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/serviceAchievement/import', 'post', params, axiosOption, httpOption);
  }
}
